import React from "react";
import insuranceCoverage from "../../assets/insurnace_coverage_.webp";
import LoyaltyRewards from "../../assets/_mtjd_loyalty_rewards.webp";
import HealthAssistance from "../../assets/health_assistance.webp";
import FlexibleWork from "../../assets/Services_2.webp";

const DriverSection4 = () => {
  return (
    <div className="mx-auto my-5 max-w-6xl px-4 text-center">
    <h2 className="text-center text-[22px] font-semibold text-[#212529] sm:text-[24px] lg:text-[28px]">
        More Than Just Deliveries
      </h2>

     <p className="mt-4 pb-4 text-[16px] text-gray-700 sm:text-[17px] md:text-[16px] lg:text-[20px] font-sf">
        Real rewards for our driver partners, because we believe your hustle,
        deserves extra support, and care.
      </p>

      <div className="mx-auto mt-8 max-w-7xl">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-x-2 lg:gap-y-6">
          {/* Card 1 */}
          <div className="flex justify-center">
          <div
  className="mx-auto flex h-full min-h-[420px] w-full max-w-[95%] lg:max-w-[98%] flex-col rounded-[16px] border p-3 text-left sm:min-h-[450px] sm:max-w-[500px] sm:p-4 lg:min-h-[480px]"
  style={{
    background: "#eef7ff",
    borderColor: "#8fd0ff",
  }}
>
              <h4 className="text-[1.2rem] font-[500] text-[#222] sm:text-[1.25rem] lg:text-[1.5rem]">
  Insurance Coverage
</h4>
              <p className="mt-3 text-[15px] text-gray-600 sm:text-[16px] md:text-[17px] lg:text-[16px]">
                Drive with peace of mind. Get access to low-cost vehicle and
                personla insurance plans, designed just for delivery partners.
              </p>

              <div className="mt-3 overflow-hidden rounded-[12px]">
                <img
                  src={insuranceCoverage}
                  className="h-[280px] w-full rounded-[12px] object-cover sm:h-[300px] lg:h-[300px]"
                  alt="Insurance Coverage"
                />
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="flex justify-center">
            <div
             className="mx-auto flex h-full min-h-[420px] w-full max-w-[95%] lg:max-w-[98%] flex-col rounded-[16px] border p-3 text-left sm:min-h-[450px] sm:max-w-[500px] sm:p-4 lg:min-h-[480px]"
              style={{
                background: "#fff5ec",
                borderColor: "#f3c38b",
              }}
            >
              <h4 className="text-[1.2rem] font-[500] text-[#222] sm:text-[1.25rem] lg:text-[1.5rem]">
                Loyalty Rewards
              </h4>
            <p className="mt-3 text-[15px] text-gray-600 sm:text-[16px] md:text-[17px] lg:text-[16px]">
                The more you drive, the more you earn. Unlock exclusive bonuses
                and milestone perks for staying active with Packky.
              </p>

              <div className="mt-3 overflow-hidden rounded-[12px]">
                <img
                  src={LoyaltyRewards}
                  className="h-[280px] w-full rounded-[12px] object-cover sm:h-[300px] lg:h-[300px]"
                  alt="Loyalty Rewards"
                />
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="flex justify-center">
            <div
             className="mx-auto flex h-full min-h-[420px] w-full max-w-[95%] lg:max-w-[98%] flex-col rounded-[16px] border p-3 text-left sm:min-h-[450px] sm:max-w-[500px] sm:p-4 lg:min-h-[480px]"
              style={{
                background: "#ecfff8",
                borderColor: "#82ead0",
              }}
            >
              <h4 className="text-[1.2rem] font-[500] text-[#222] sm:text-[1.25rem] lg:text-[1.5rem]">
                Health Assistance
              </h4>
             <p className="mt-3 text-[15px] text-gray-600 sm:text-[16px] md:text-[17px] lg:text-[16px]">
                Stay strong on and off the road with affordable healthcare for
                you and your family, plus easy access to medical support.
              </p>

              <div className="mt-3 overflow-hidden rounded-[12px]">
                <img
                  src={HealthAssistance}
                  className="h-[280px] w-full rounded-[12px] object-cover sm:h-[300px] lg:h-[300px]"
                  alt="Health Assistance"
                />
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="flex justify-center">
            <div
             className="mx-auto flex h-full min-h-[420px] w-full max-w-[95%] lg:max-w-[98%] flex-col rounded-[16px] border p-3 text-left sm:min-h-[450px] sm:max-w-[500px] sm:p-4 lg:min-h-[480px]"
              style={{
                background: "#faf0ff",
                borderColor: "#d7a7ff",
              }}
            >
              <h4 className="text-[1.2rem] font-[500] text-[#222] sm:text-[1.25rem] lg:text-[1.5rem]">
                Flexible Work
              </h4>
              <p className="mt-3 text-[15px] text-gray-600 sm:text-[16px] md:text-[17px] lg:text-[16px]">
                Be your own boss. Choose when, where, and how much you want to
                drive -- part-time or full-time, it's up to you.
              </p>

              <div className="mt-3 overflow-hidden rounded-[12px]">
                <img
                  src={FlexibleWork}
                  className="h-[280px] w-full rounded-[12px] object-cover sm:h-[300px] lg:h-[300px]"
                  alt="Flexible Work"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverSection4;